<template>
	<div class="insights-box col-md-12 col-sm-12 col-xs-12 margin-top-20">
		<a :id="insight.id">&nbsp;</a>
		<div class="header">
			<h2>
				{{ insight.title }}
			</h2>
		</div>
		<div class="more">
			<p>
				<vue-markdown>{{ insight.text }}</vue-markdown>
			</p>
			<div v-if="showCTA" class="margin-top-20 text-center">
				<div class="margin-bottom-20">
					<h5>{{ insight.cta_title }}</h5>
				</div>
				<a rel="nofollow" :href="insight.cta_link" class="button button-2">
					{{ insight.cta_value }}
				</a>
			</div>
		</div>
	</div>
</template>

<script>
import VueMarkdown from 'vue-markdown-v2'

export default {
	name: 'InsightsContainerBox',
	components: {
		VueMarkdown,
	},
	props: {
		insight: {
			type: Object,
			required: true,
		},
	},
	computed: {
		showCTA() {
			return this.insight.cta_link && this.insight.cta_value
		},
	},
}
</script>



// WEBPACK FOOTER //
// src/components/sections/boxes/InsightsContainerBox.vue